import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _courseMedia = [];

let CourseMediaStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getById: function(id) {
        return _courseMedia.find(function(e) {
            return e !== undefined && e.id == id
        });
    },
    add: function(data) {
        var mediaIndex = _courseMedia.findIndex( function(e) {
            return e !== undefined && e.id == data.id;
        });

        if (mediaIndex < 0) {
            _courseMedia.push(data);
        } else {
            _courseMedia[mediaIndex] = data;
        }
    },
});

CourseMediaStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.COURSE_MEDIA_INFO:
            CourseMediaStore.add(action.data);
            CourseMediaStore.emitChange();
            break;

        case ActionTypes.COURSE_MEDIA_INFO_ERROR:
            CourseMediaStore.emitChange();
            break;

        case ActionTypes.COURSE_MEDIA_PUBLISH:
            // on successful publishing, this returns with the new details
            CourseMediaStore.add(action.data);
            CourseMediaStore.emitChange();
            break;

        case ActionTypes.COURSE_MEDIA_PUBLISH_ERROR:
            CourseMediaStore.emitChange();
            break;

        default:
            break;
    }

});

export default CourseMediaStore;
